import React from "react";

export default function HeaderActionButton({
  iconSrc,
  iconAlt,
  label,
  onClick,
  containerClassName,
  buttonClassName = "cursor-pointer sm:mx-2 m-0",
  imageClassName = "h-[22px] w-[22px] md:h-[24px] md:w-[24px] mx-auto",
  labelClassName = "font-[700] md:text-[12px] text-[#ffffff] text-[8px] text-center",
}) {
  return (
    <div className={containerClassName}>
      <button type="button" className={buttonClassName} onClick={onClick}>
        <img src={iconSrc} alt={iconAlt} className={imageClassName} />
        <p className={labelClassName}>{label}</p>
      </button>
    </div>
  );
}
